import { type RefObject } from 'react';

import { useActive } from './useActive';
import { useFocused } from './useFocused';
import { useHovered } from './useHovered';

export const usePressableState = (ref: RefObject<HTMLElement | null>) => {
  const isHovered = useHovered(ref);
  const isFocused = useFocused(ref);
  const isActive = useActive(ref);
  const isInteracting = isHovered || isActive;

  return { isInteracting, isHovered, isFocused, isActive };
};
